const initialState = {
  packs: [],
  pack: {},
};

const packs = (state = initialState, action) => {
  switch (action.type) {
    case 'GET_PACKS':
      return { ...state, packs: action.packs };
    case 'EDIT_PACK':
      return { ...state, pack: action.pack };
    case 'DELETE_PACK':
      return { ...state, packs: state.packs.filter((pack) => pack.objectId !== action.id) };
    default:
      return state;
  }
};

export default packs;
